import { Wrapper } from './ComplementaryMaterial.styles';
import { ComplementaryMaterialSections } from './ComplementaryMaterialSections';
import { PageConfiguration } from './PageConfiguration';

export const ComplementaryMaterial = () => {
  return (
    <Wrapper>
      <PageConfiguration />
      <ComplementaryMaterialSections />
    </Wrapper>
  );
};
